import { graphql } from "@opensea/graphql"
import { ChainBadgeFragment } from "../ChainBadge/ChainBadge.fragment"

export const CollectionLockupFragment = graphql(
  `
    fragment CollectionLockup on Collection {
      name
      imageUrl
      animationUrl
      isVerified
      chain {
        ...ChainBadge
      }
    }
  `,
  [ChainBadgeFragment],
)
